import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_API_KEY = 'donation/campaign';

export function useGetCampaignByIdQuery({
	enabled = true,
	id,
	impersonationContext,
}: {
	enabled?: boolean;
	id: string;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryKey: [BASE_API_KEY, id],

		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IDonationCampaign>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'donation/campaign',
					impersonationContext,
					queryParams: {
						id,
					},
				}),
				'GET'
			);
		},
	});
}
